import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';
  angular.module('app').service('ExchangeRateService', ExchangeRateService);

  ExchangeRateService.$inject = [
    'RestResource',
    '$translate',
    'UtilService',
    'ExchangeRateModalService',
  ];

  function ExchangeRateService(RestResource, $translate, UtilService, ExchangeRateModalService) {
    let utils = new UtilService(this);

    let apiUrl = environment.apiEndpoint + 'exchange_rates';

    let service = {
      getFilterCriteria: getFilterCriteria,
      getExchangeRates: getExchangeRates,
      getExchangeRate: getExchangeRate,
      saveExchangeRate: saveExchangeRate,
      deleteExchangeRate: deleteExchangeRate,
      changeExchangeRateStatus: changeExchangeRateStatus,
      updateExchangeRates: updateExchangeRates,
      openExchangeRateListModal: openExchangeRateListModal,

      getExchangeRateValue: getExchangeRateValue,

      getDocumentDateExchangeRate: getDocumentDateExchangeRate,
      getDocumentDateExchangeRateForConversions: getDocumentDateExchangeRateForConversions,

      applyExchangeRateConversion: applyExchangeRateConversion,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      let filter = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'from',
      };

      return filter;
    }

    function getExchangeRates(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getExchangeRate(id, params) {
      if (!params) {
        params = {};
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveExchangeRate(item) {
      let method = item.id ? 'put' : 'post';
      let url = item.id ? apiUrl + '/' + item.id : apiUrl;

      function success(response) {
        let msg = !item.id ? 'EXCHANGE_RATE_CREATED' : 'EXCHANGE_RATE_MODIFIED';
        utils._successMsg($translate.instant(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, item, success, failure);
    }

    function deleteExchangeRate(item, successCallback) {
      let params = {
        title: 'DELETE_EXCHANGE_RATE',
        // body:       'DELETING_EXCHANGE_RATE_WARNING',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'EXCHANGE_RATE_DELETED',
      };

      let url = apiUrl + '/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function changeExchangeRateStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function updateExchangeRates(action, items, successCallback) {
      utils.updateItems(apiUrl, action, items, successCallback);
    }

    function openExchangeRateListModal(
      currency,
      companyId,
      companyCountryCode,
      companyBaseCurrency,
      companyTimeZoneUtc,
      mode,
      successCallback
    ) {
      ExchangeRateModalService.openExchangeRateListModal(
        currency,
        companyId,
        companyCountryCode,
        companyBaseCurrency,
        companyTimeZoneUtc,
        mode,
        successCallback
      );
    }

    // The exchange rates are based on the base company currency
    function getExchangeRateValue(currenciesPerCompany, currencyId) {
      // , documentDate
      if (!currenciesPerCompany) return false; // \\ currenciesPerCompany.length === 0

      // console.log('currenciesPerCompany:', currenciesPerCompany);

      let currency = currenciesPerCompany.find(
        (currencyPerCompany) => currencyPerCompany.id === currencyId
      );

      // console.log('currency:', currency);

      if (!currency.todayExchangeRate) {
        return false;
      }

      return currency.todayExchangeRate.rate;
    }

    // Get exchange rates - When adding or editing items
    function getDocumentDateExchangeRate(
      currenciesPerCompany,
      companyBaseCurrencyId,
      currencyId,
      priceListCurrencyId
    ) {
      // , documentDate
      // console.log('getDocumentDateExchangeRate');

      // console.log('companyBaseCurrencyId: ', companyBaseCurrencyId);
      // console.log('currencyId: ', currencyId);
      // console.log('priceListCurrencyId: ', priceListCurrencyId);

      // let currencyId = currency.id;

      let exchangeRateValue;

      // For bookings
      // Get exchange rates for price list and sale currency => priceListCurrencyId, currencyId
      // If it is the base currency, it doesn't require exchange rates
      if (priceListCurrencyId) {
        // CBC = ₡
        // PLC = $
        // C   = $
        // (multiply by 1)
        // We do not require exchange rate as priceListCurrencyId = currencyId
        if (priceListCurrencyId === currencyId) {
          // console.log('-one');

          /* if (currencyId === companyBaseCurrencyId) {
            console.log('-one A');
            exchangeRateValue = 1;
          } else {
            console.log('-one B');
            exchangeRateValue = getExchangeRateValue(currenciesPerCompany, priceListCurrencyId);
          } */

          exchangeRateValue = 1;

          return {
            value: 1, // for conversions
            conversion: 'multiply',
            exchangeRateValue: exchangeRateValue,
          };
        }

        // CBC = $
        // PLC = $
        // C   = ₡
        // (divide by 600*)
        if (priceListCurrencyId === companyBaseCurrencyId) {
          // console.log('-two');
          exchangeRateValue = getExchangeRateValue(currenciesPerCompany, currencyId); // , documentDate

          return {
            value: exchangeRateValue, // for conversions
            conversion: 'divide',
            exchangeRateValue: exchangeRateValue,
          };
        }

        // CBC = ₡
        // PLC = $
        // C   = ₡
        // (multiply by 600*)
        if (currencyId === companyBaseCurrencyId) {
          // console.log('-three');
          exchangeRateValue = getExchangeRateValue(currenciesPerCompany, priceListCurrencyId); // , documentDate

          return {
            value: exchangeRateValue, // for conversions
            conversion: 'multiply',
            exchangeRateValue: exchangeRateValue, // 1
          };
        }

        // CBC = ₡
        // PLC = $
        // C   = €
        // (multiply 600* and then divide by 700*)
        // console.log('-four');
        exchangeRateValue = getExchangeRateValue(currenciesPerCompany, priceListCurrencyId); // , documentDate
        let otherCurrencyExchangeRateValue = getExchangeRateValue(currenciesPerCompany, currencyId); // , documentDate

        let value =
          exchangeRateValue && otherCurrencyExchangeRateValue
            ? [exchangeRateValue, otherCurrencyExchangeRateValue]
            : false;

        return {
          value: value, // value, // [600*, 700*]
          conversion: 'convert',
          exchangeRateValue: otherCurrencyExchangeRateValue, // 700*
        };
      }
      // Invoices and other transactions
      // Get exchange rates for sale currency => currencyId
      else {
        let exchangeRateValue = 1;

        if (currencyId !== companyBaseCurrencyId) {
          exchangeRateValue = getExchangeRateValue(currenciesPerCompany, currencyId); // , documentDate
        }

        return {
          value: exchangeRateValue,
        };
      }
    }

    // For Conversions
    function getDocumentDateExchangeRateForConversions(
      currenciesPerCompany,
      companyBaseCurrencyId,
      currencyId,
      lastCurrencyId
    ) {
      let exchangeRateValue;

      // Sale currency is the baseCurrency
      // CBC = ₡ / SC = ₡ / Last SC = $ (multiply)
      if (currencyId === companyBaseCurrencyId) {
        // console.log('one');
        exchangeRateValue = getExchangeRateValue(currenciesPerCompany, lastCurrencyId); // , documentDate
        return {
          value: exchangeRateValue,
          conversion: 'multiply',
        };
      }

      // CBC = ₡ / SC = $ / Last SC = ₡ (divide)
      if (lastCurrencyId === companyBaseCurrencyId) {
        // console.log('two');
        exchangeRateValue = getExchangeRateValue(currenciesPerCompany, currencyId); // , documentDate
        return {
          value: exchangeRateValue,
          conversion: 'divide',
        };
      }

      // console.log('three');
      // CBC = ₡ / SC = € / Last SC = $ (convert)
      exchangeRateValue = getExchangeRateValue(currenciesPerCompany, lastCurrencyId); // , documentDate
      let otherCurrencyExchangeRateValue = getExchangeRateValue(currenciesPerCompany, currencyId); // , documentDate
      return {
        value: [exchangeRateValue, otherCurrencyExchangeRateValue],
        conversion: 'convert',
      };
    }

    // For all transactions
    function applyExchangeRateConversion(amount, documentDateExchangeRate) {
      if (amount === 0) return amount;

      let value;

      switch (documentDateExchangeRate.conversion) {
        case 'multiply':
          value = amount * documentDateExchangeRate.value;
          break;
        case 'divide':
          value = amount / documentDateExchangeRate.value;
          break;
        default:
          value = (amount * documentDateExchangeRate.value[0]) / documentDateExchangeRate.value[1];
          break;
      }

      // return value;
      return utils.roundNum(value);
    }
  }
})();
